var app = angular.module('tf.brokerDisclaimer', [])

    .controller('brokerDisclaimerCtrl', ['$scope', '$uibModalInstance', 'broker', function gamePopupsController($scope, $uibModalInstance, broker) {

        $scope.broker = broker;

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };



    }]);
